import type { FC } from 'react';

import { Button } from '@ipfabric/ui-components/Button/Button';
import { LoaderAndText } from 'containers/LoaderAndText/LoaderAndText';
import React from 'react';
import { apiEndpointToBaseUrl } from 'utils/apiEndpointToFullUrl';
import { useApiScopeRequirementMet } from 'utils/permissions/useApiScopeRequirementMet';

type ExtensionsDialogLogsProps = {
  extensionId: string;
  logs: string[];
  logsRefreshing: boolean;
  refreshExtensionLogs: () => void;
};

export const ExtensionsDialogLogs: FC<ExtensionsDialogLogsProps> = React.memo(
  (props: ExtensionsDialogLogsProps) => {
    const apiScopeRequirementMet = useApiScopeRequirementMet();
    const isAllowedToSeeLogs = apiScopeRequirementMet({
      method: 'GET',
      path: '/extensions/:extensionId/logs',
    });
    const isAllowedToDownloadLogs = apiScopeRequirementMet({
      method: 'GET',
      path: '/extensions/:extensionId/logs/download',
    });
    return (
      <>
        <div className='mt-4'>
          {isAllowedToSeeLogs && (
            <>
              <div className='block mb-2'>
                Logs <small>(last 200 lines)</small>
              </div>
              {props.logsRefreshing ? (
                <div className='flex justify-center items-center h-20'>
                  <LoaderAndText />
                </div>
              ) : (
                <pre className='break-words whitespace-pre-wrap max-h-[300px] overflow-auto'>
                  {(props.logs ?? []).join('\n')}
                </pre>
              )}
            </>
          )}
          <div className='flex gap-2'>
            {isAllowedToSeeLogs && (
              <Button
                renderAs='button'
                onClick={props.refreshExtensionLogs}
                icon='fa-rotate-right'
                size='small'
                variant='plain'
                loading={props.logsRefreshing}
              >
                Refresh logs
              </Button>
            )}
            {isAllowedToDownloadLogs && (
              <Button
                renderAs='anchor'
                href={apiEndpointToBaseUrl(
                  `/extensions/${props.extensionId}/logs/download`,
                )}
                icon='fa-file-lines'
                size='small'
                variant='plain'
                disabled={props.logsRefreshing}
              >
                Download complete logs
              </Button>
            )}
          </div>
        </div>
      </>
    );
  },
);
